export const MEMBERS_AREA_V2_APP_ID = 'b976560c-3122-4351-878f-453f337b7245';
export const MEMBERS_INFO_APP_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
export const EVENTS_APP_ID = '140603ad-af8d-84a5-2c80-a0f60cb47351';
export const ZOOM_APP_ID = 'c6d111d1-1a8d-49f0-a78c-4f1823fb6592';
export const GROUPS_APP_ID = '148c2287-c669-d849-d153-463c7486a694';
export const SEATINGS_APP_ID = '64e6bcf3-b6e2-456a-81f9-b0cfbdd5c2c3';
export const PAPYRUS_APP_ID = 'edd04d8e-3c81-46d7-b176-39b076fe7bbd';
export const MEMBERS_APP_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
export const PAID_PLANS_APP_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const EVENT_LIST_SECTION_ID = 'Event List';
export const EVENT_DETAILS_SECTION_ID = 'events';
export const BUILDER_EVENT_DETAILS_SECTION_ID = 'event-details-builder';
export const BUILDER_EVENT_LIST_SECTION_ID = 'event-list';
export const BUILDER_EVENT_REGISTRATION_SECTION_ID = 'event-registration-builder';
export const BUILDER_EVENT_SEATING_SECTION_ID = 'event-seating-builder';
export const BUILDER_EVENT_THANK_YOU_SECTION_ID = 'event-thank-you-builder';
export const SCHEDULE_SECTION_ID = 'Schedule';
export const MEMBERS_INFO_SECTION_ID = 'member_info';
export const MEMBERS_AREA_V2_SECTION_ID = 'member_page';
export const MEMBERS_PAGE_SECTION_ID = 'events_members_page';
export const PAID_PLANS_SECTION_ID = 'membership_plan_picker_tpa';
export const GROUPS_SECTION_ID = 'group';
export const EVENTS_WIDGET_ID = '1440e92d-47d8-69be-ade7-e6de40127106';
export const EVENTS_MEMBERS_WIDGET_ID = '405eb115-a694-4e2b-abaa-e4762808bb93';
export const EVENTS_DETAILS_PAGE_ID = '14d2abc2-5350-6322-487d-8c16ff833c8a';
export const EVENTS_SCHEDULE_PAGE_ID = '29ad290c-8529-4204-8fcf-41ef46e0d3b0';
